<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <div @click="launchFilePicker()" class="slot-activator">
      <slot name="activator"></slot>
    </div>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input
      type="file"
      ref="file"
      :name="uploadFieldName"
      @change="onFileChange($event.target.name, $event.target.files)"
      style="display: none"
    />
  </div>
</template>
<style scoped>
.slot-activator {
  height: 120px;
}
</style>
<script>
export default {
  name: "image-input",
  data: () => ({
    errorDialog: null,
    errorText: "",
    uploadFieldName: "file",
    maxSize: 1024,
    previewURL: null,
  }),
  props: {
    // Use "value" to enable using v-model
    value: Object,
  },
  beforeDestroy() {
    this.revokePreviewURL();
  },
  methods: {
    revokePreviewURL() {
      //release the previous preview blob, the parent no longer renders it
      if (this.previewURL) {
        URL.revokeObjectURL(this.previewURL);
        this.previewURL = null;
      }
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    fileToBase64(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(file);
      });
    },
    onFileChange(fieldName, file) {
      const { maxSize } = this;
      let imageFile = file[0];
      if (file.length > 0) {
        let size = imageFile.size / maxSize / maxSize;
        if (!imageFile.type.match("image.*")) {
          // check whether the upload is an image
          this.errorDialog = true;
          this.errorText = "Please choose an image file";
        } else if (size > 1) {
          // check whether the size is greater than the size limit
          this.errorDialog = true;
          this.errorText =
            "Your file is too big! Please select an image under 1MB";
        } else {
          // Append file into FormData and turn file into image URL
          let formData = new FormData();
          let imageString = "";
          this.revokePreviewURL();
          let imageURL = URL.createObjectURL(imageFile);
          this.previewURL = imageURL;
          formData.append(fieldName, imageFile);
          // Emit the FormData and image URL to the parent component
          //this.$emit('input', { formData, imageURL })
          this.fileToBase64(
            //document.getElementById("fileUpload").files[0]
            file[0]
          ).then((base64String) => {
            imageString = base64String;
            let isUpload = true;
            let imageType = imageFile ? imageFile.name : "";
            if (imageType) {
              imageType = imageType.split(".");
              if (imageType && imageType.length >= 1) {
                imageType = imageType[imageType.length - 1];
              }
            }
            // Emit the FormData and image URL to the parent component
            this.$emit("input", {
              formData,
              imageURL,
              imageString,
              isUpload,
              imageType,
            });
          });
        }
      }
    },
  },
};
</script>
